
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { PageInWP } from "@/lib/singularity/wp-page-manager/types";
import {
  deletePageFromWP,
  updatePageInWP
} from "@/lib/singularity/wp-page-manager/pages";
import { saveToWordPressWithErrorsLoggedToUiStore } from "@/lib/wordpress/save";
import { replaceDocumentWithAnother } from "@/lib/wordpress/load";
import IconButton from "@/components/UI/IconButton.vue";
import Icon from "@/components/UI/Icon.vue";
import { documentStore, singularityStore } from "@/store/store";
import { behindTheScenesPageGeneration } from "@/lib/singularity/behind-the-scenes-page-generation";
import { aiJobController } from "@/types/singularity/ai-jobs";
import { generatePageInTheBackground } from "@/futurelayer/pages/background-page-generation";
import Dropdown from "@/components/Reusable/Dropdown/Dropdown.vue";
import { open } from "fs";

@Component({
  components: {
    IconButton,
    Icon,
    Dropdown
  }
})
export default class WPPageManagerPage extends Vue {
  @Prop()
  value!: PageInWP;

  mounted() {
    this.generatePageInTheBackgroundIfNecessary();
  }

  get isHomepage() {
    return this.value.title.toLowerCase().includes("home");
  }

  generatingPageInTheBackground = false;
  async generatePageInTheBackgroundIfNecessary() {
    if (this.active) return;

    if (
      this.value.singularityMeta &&
      this.value.singularityMeta.initialSectionsAlreadyPopulated
    )
      return;

    this.generatingPageInTheBackground = true;
    await generatePageInTheBackground(this.value.title, this.value.id);
    this.generatingPageInTheBackground = false;
  }

  openingInProgress = false;

  additionalOpen = false;
  openAdditional() {
    this.additionalOpen = !this.additionalOpen;
  }

  async openInCanvas() {
    this.openingInProgress = true;
    await saveToWordPressWithErrorsLoggedToUiStore();
    await replaceDocumentWithAnother(this.value.id);
    singularityStore.setSingularityLeftPanel("page_structure");
    this.openingInProgress = false;
  }

  deleteInProgress = false;

  async deletePage() {
    this.deleteInProgress = true;
    await deletePageFromWP(this.value.id);
    this.deleteInProgress = false;
  }

  editing = false;

  newTitle = "";
  setEditMode() {
    this.editing = true;
    this.$nextTick(() => {
      (this.$refs.editTitleInput as HTMLInputElement).focus();
    });
  }

  updateInProgress = false;
  async updatePage(newTitle: string) {
    if (!newTitle.trim()) {
      this.editing = false;
      return;
    }
    this.updateInProgress = true;
    await updatePageInWP(this.value.id, newTitle);
    this.updateInProgress = false;
    this.editing = false;
  }

  get active() {
    return this.value.id === documentStore.document.documentMeta.id;
  }

  get classList() {
    return {
      "is-active": this.active
    };
  }

  generating = false;
  setGenerating(generating: boolean) {
    this.generating = generating;
  }

  async fastGenerateBehindTheScenes() {
    this.generating = true;

    await generatePageInTheBackground(this.value.title, this.value.id);

    this.generating = false;
  }

  async generateBehindTheScenes() {
    console.log("Generating behind the scenes page for", this.value.id);

    aiJobController.addJob(
      async abortController => {
        this.setGenerating(true);
        await behindTheScenesPageGeneration(this.value.id, abortController);
        this.setGenerating(false);
      },
      "behind the scenes page generation for " + this.value.title,
      false
    );
  }
}
